import * as ReactDOM from "react-dom";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import SecureRoutes from "./components/SecureRoutes/SecureRoutes";

import "./App.css";
import AccountRecovery from "./components/Views/AccountRecovery";
import AllPaymentsDashboard from "./components/Views/AllPaymentsDashboard/AllPaymentsDashboard";
import CreditCardCheckout from "./components/Views/CreditCardCheckout";
import UsersDashboard from "./components/Views/CustomersDashboard/UsersDashboard";
import EmailValidation from "./components/Views/EmailValidation";
import ErrorView from "./components/Views/ErrorView";
import LandingPageView from "./components/Views/Landing";
import LoginView from "./components/Views/Login";
import NotFoundView from "./components/Views/NotFound";
import PaymentMethods from "./components/Views/PaymentMethods";
import PaymentPlansView from "./components/Views/PaymentPlans";
import PaymentsHistoryView from "./components/Views/PaymentsHistory";
import PixCheckout from "./components/Views/PixCheckout/PixCheckout";
import QuestionaryView from "./components/Views/Questionary";
import RegisterPage from "./components/Views/Register";
import Upsell from "./components/Views/Upsell/Upsell";
import Wo from "./components/Views/Workspace";
import Home from "./components/Views/Home/Home";

const router = createBrowserRouter([
  {
    path: "/",
    element: <SecureRoutes />,
    errorElement: <ErrorView />,
    children: [
      {
        path: "/formulario",
        element: <QuestionaryView />,
        errorElement: <ErrorView />,
      },
      {
        path: "/user-dashboard",
        element: <UsersDashboard />,
        errorElement: <ErrorView />,
      },

      {
        path: "/user-payments-dashboard",
        element: <AllPaymentsDashboard />,
        errorElement: <ErrorView />,
      },
      {
        path: "/editor",
        element: <Wo />,
        errorElement: <ErrorView />,
      },
      {
        path: "/encartes",
        element: <Home />,
        index: true,
        errorElement: <ErrorView />,
      },
      {
        path: "/assinatura/checkout-cartao",
        element: <CreditCardCheckout />,
        errorElement: <ErrorView />,
      },
      {
        path: "/assinatura/checkout-pix",
        element: <PixCheckout />,
        errorElement: <ErrorView />,
      },
      {
        path: "/planos",
        element: <PaymentPlansView />,
        errorElement: <ErrorView />,
      },
      {
        path: "/pagamentos",
        element: <PaymentsHistoryView />,
        errorElement: <ErrorView />,
      },
      {
        path: "/metodo-pagamento",
        element: <PaymentMethods />,
        errorElement: <ErrorView />,
      },
      {
        path: "/oferta-especial",
        element: <Upsell />,
        errorElement: <ErrorView />,
      },
    ],
  },
  {
    path: "/verificacao-email",
    element: <EmailValidation />,
    errorElement: <ErrorView />,
  },
  {
    path: "/recuperar-conta",
    element: <AccountRecovery />,
    errorElement: <ErrorView />,
  },
  {
    path: "/registrar",
    element: <RegisterPage />,
    errorElement: <ErrorView />,
  },

  {
    path: "/entrar",
    element: <LoginView />,
    index: true,
    errorElement: <ErrorView />,
  },

  {
    path: "/",
    element: <LandingPageView />,
    index: true,
  },
  {
    path: "*",
    element: <NotFoundView />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />,
);
